angular.module('internal.documents', [])
    .config(['$stateProvider',
        /**
         * @param {ui.IStateProvider} $stateProvider
         */
        function ($stateProvider) {
            $stateProvider.state('internal.documents', {
                url: '/documents/:prevState',
                views: {
                    content: {
                        controllerAs: 'vm',
                        controller: 'DocumentsController',
                        templateUrl: 'js/internal/documents/documents/documents.html',
                    }
                }
            });

        }]);
